module.exports = __webpack_public_path__ + "img/plb1.de978c84.jpeg";